<template>
  <input
    type="range"
    :value="valueDisplayed"
    :disabled="disabled"
    :min="min"
    :max="max"
    :step="step"
    @change="handleValue"
  >
</template>
<script>

function initialData() {
  return {
    valueSelected: null,
  };
}

export default {
  name: 'BaseSlider',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 5,
    },
    max: {
      type: Number,
      default: 10,
    },
    min: {
      type: Number,
      default: 0,
    },
    step: {
      type: Number,
      default: 1,
    },
    minAcceptableValue: {
      type: Number,
      default: undefined,
    },
    maxAcceptableValue: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return initialData();
  },
  computed: {
    valueDisplayed() {
      return this.valueSelected || this.value;
    },
  },
  methods: {
    handleValue(e) {
      const currentValue = e.target.value;
      this.valueSelected = currentValue;
      if (this.minAcceptableValue !== undefined || this.maxAcceptableValue !== undefined) {
        if (this.minAcceptableValue !== undefined && currentValue < this.minAcceptableValue) {
          this.valueSelected = this.minAcceptableValue;
        }
        if (this.maxAcceptableValue !== undefined && currentValue > this.maxAcceptableValue) {
          this.valueSelected = this.maxAcceptableValue;
        }
      }
      this.$emit('updateValue', this.valueSelected);
    },
  },
};
</script>
<style scoped lang="scss">
input[type="range"] {
  accent-color: $primary-light;
}
</style>
